import React, { useState } from 'react';
import { DollarSign, TrendingUp, TrendingDown, Download, Calendar, Filter, BarChart3, PieChart, Activity } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
export function FinancialReport() {
  const [dateRange, setDateRange] = useState('30days');
  return <div className="space-y-6" data-id="element-615">
      {/* Header */}
      <div className="flex justify-between items-start" data-id="element-616">
        <div data-id="element-617">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-618">
            Laporan Keuangan
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-619">
            Analisis pendapatan dan margin bisnis
          </p>
        </div>
        <div className="flex gap-2" data-id="element-620">
          <select value={dateRange} onChange={e => setDateRange(e.target.value)} className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-621">
            <option value="7days" data-id="element-622">7 Hari Terakhir</option>
            <option value="30days" data-id="element-623">30 Hari Terakhir</option>
            <option value="90days" data-id="element-624">3 Bulan Terakhir</option>
            <option value="1year" data-id="element-625">1 Tahun</option>
          </select>
          <Button variant="outline" icon={<Filter className="w-4 h-4" data-id="element-627" />} data-id="element-626">
            Filter
          </Button>
          <Button variant="primary" icon={<Download className="w-4 h-4" data-id="element-629" />} data-id="element-628">
            Ekspor Laporan
          </Button>
        </div>
      </div>

      {/* KPI Cards - Futuristic Design */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-630">
        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-blue-500 to-blue-600 text-white border-0 shadow-xl shadow-blue-200" data-id="element-631">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-632">
            <DollarSign className="w-full h-full" data-id="element-633" />
          </div>
          <div className="relative z-10" data-id="element-634">
            <div className="flex items-center gap-3 mb-3" data-id="element-635">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-636">
                <DollarSign className="w-6 h-6 text-white" data-id="element-637" />
              </div>
              <Badge className="bg-green-400 text-green-900 border-0" data-id="element-638">
                <TrendingUp className="w-3 h-3 mr-1" data-id="element-639" />
                +12%
              </Badge>
            </div>
            <p className="text-sm text-blue-100 mb-1" data-id="element-640">Total Pendapatan</p>
            <p className="text-4xl font-extrabold" data-id="element-641">Rp 125Jt</p>
            <p className="text-xs text-blue-200 mt-2" data-id="element-642">
              vs bulan lalu: Rp 112Jt
            </p>
          </div>
        </Card>

        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-green-500 to-green-600 text-white border-0 shadow-xl shadow-green-200" data-id="element-643">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-644">
            <TrendingUp className="w-full h-full" data-id="element-645" />
          </div>
          <div className="relative z-10" data-id="element-646">
            <div className="flex items-center gap-3 mb-3" data-id="element-647">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-648">
                <TrendingUp className="w-6 h-6 text-white" data-id="element-649" />
              </div>
              <Badge className="bg-green-400 text-green-900 border-0" data-id="element-650">
                <TrendingUp className="w-3 h-3 mr-1" data-id="element-651" />
                +8%
              </Badge>
            </div>
            <p className="text-sm text-green-100 mb-1" data-id="element-652">Gross Margin</p>
            <p className="text-4xl font-extrabold" data-id="element-653">18,5%</p>
            <p className="text-xs text-green-200 mt-2" data-id="element-654">Target: 20%</p>
          </div>
        </Card>

        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-violet-500 to-violet-600 text-white border-0 shadow-xl shadow-violet-200" data-id="element-655">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-656">
            <BarChart3 className="w-full h-full" data-id="element-657" />
          </div>
          <div className="relative z-10" data-id="element-658">
            <div className="flex items-center gap-3 mb-3" data-id="element-659">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-660">
                <DollarSign className="w-6 h-6 text-white" data-id="element-661" />
              </div>
              <Badge className="bg-green-400 text-green-900 border-0" data-id="element-662">
                <TrendingUp className="w-3 h-3 mr-1" data-id="element-663" />
                +5%
              </Badge>
            </div>
            <p className="text-sm text-violet-100 mb-1" data-id="element-664">Net Profit</p>
            <p className="text-4xl font-extrabold" data-id="element-665">Rp 23Jt</p>
            <p className="text-xs text-violet-200 mt-2" data-id="element-666">Margin: 18.4%</p>
          </div>
        </Card>

        <Card className="p-6 relative overflow-hidden bg-gradient-to-br from-amber-500 to-amber-600 text-white border-0 shadow-xl shadow-amber-200" data-id="element-667">
          <div className="absolute top-0 right-0 w-32 h-32 opacity-10" data-id="element-668">
            <Activity className="w-full h-full" data-id="element-669" />
          </div>
          <div className="relative z-10" data-id="element-670">
            <div className="flex items-center gap-3 mb-3" data-id="element-671">
              <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center" data-id="element-672">
                <TrendingDown className="w-6 h-6 text-white" data-id="element-673" />
              </div>
              <Badge className="bg-red-400 text-red-900 border-0" data-id="element-674">
                <TrendingDown className="w-3 h-3 mr-1" data-id="element-675" />
                -3%
              </Badge>
            </div>
            <p className="text-sm text-amber-100 mb-1" data-id="element-676">Biaya Operasional</p>
            <p className="text-4xl font-extrabold" data-id="element-677">Rp 102Jt</p>
            <p className="text-xs text-amber-200 mt-2" data-id="element-678">81.6% dari revenue</p>
          </div>
        </Card>
      </div>

      {/* Charts Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-679">
        {/* Revenue Trend */}
        <Card className="lg:col-span-2 p-6" data-id="element-680">
          <div className="flex items-center justify-between mb-6" data-id="element-681">
            <div className="flex items-center gap-3" data-id="element-682">
              <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center" data-id="element-683">
                <BarChart3 className="w-5 h-5 text-blue-600" data-id="element-684" />
              </div>
              <div data-id="element-685">
                <h3 className="font-bold text-lg text-slate-900" data-id="element-686">
                  Tren Pendapatan
                </h3>
                <p className="text-sm text-slate-500" data-id="element-687">30 hari terakhir</p>
              </div>
            </div>
          </div>

          {/* Placeholder for Chart */}
          <div className="h-80 bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl border-2 border-dashed border-slate-300 flex flex-col items-center justify-center" data-id="element-688">
            <BarChart3 className="w-16 h-16 text-slate-400 mb-4" data-id="element-689" />
            <p className="text-slate-600 font-medium" data-id="element-690">Grafik Pendapatan</p>
            <p className="text-sm text-slate-400 mt-1" data-id="element-691">
              Visualisasi data akan ditampilkan di sini
            </p>
          </div>
        </Card>

        {/* Breakdown */}
        <Card className="p-6" data-id="element-692">
          <div className="flex items-center gap-3 mb-6" data-id="element-693">
            <div className="w-10 h-10 bg-violet-100 rounded-lg flex items-center justify-center" data-id="element-694">
              <PieChart className="w-5 h-5 text-violet-600" data-id="element-695" />
            </div>
            <div data-id="element-696">
              <h3 className="font-bold text-lg text-slate-900" data-id="element-697">
                Breakdown Biaya
              </h3>
              <p className="text-sm text-slate-500" data-id="element-698">Distribusi pengeluaran</p>
            </div>
          </div>

          <div className="space-y-4" data-id="element-699">
            <div data-id="element-700">
              <div className="flex justify-between items-center mb-2" data-id="element-701">
                <span className="text-sm font-medium text-slate-700" data-id="element-702">
                  Cost of Goods
                </span>
                <span className="text-sm font-bold text-slate-900" data-id="element-703">65%</span>
              </div>
              <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-704">
                <div className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full" style={{
                width: '65%'
              }} data-id="element-705"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-706">Rp 66.3Jt</p>
            </div>

            <div data-id="element-707">
              <div className="flex justify-between items-center mb-2" data-id="element-708">
                <span className="text-sm font-medium text-slate-700" data-id="element-709">
                  Logistik
                </span>
                <span className="text-sm font-bold text-slate-900" data-id="element-710">20%</span>
              </div>
              <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-711">
                <div className="h-full bg-gradient-to-r from-green-500 to-green-600 rounded-full" style={{
                width: '20%'
              }} data-id="element-712"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-713">Rp 20.4Jt</p>
            </div>

            <div data-id="element-714">
              <div className="flex justify-between items-center mb-2" data-id="element-715">
                <span className="text-sm font-medium text-slate-700" data-id="element-716">
                  Operasional
                </span>
                <span className="text-sm font-bold text-slate-900" data-id="element-717">10%</span>
              </div>
              <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-718">
                <div className="h-full bg-gradient-to-r from-violet-500 to-violet-600 rounded-full" style={{
                width: '10%'
              }} data-id="element-719"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-720">Rp 10.2Jt</p>
            </div>

            <div data-id="element-721">
              <div className="flex justify-between items-center mb-2" data-id="element-722">
                <span className="text-sm font-medium text-slate-700" data-id="element-723">
                  Marketing
                </span>
                <span className="text-sm font-bold text-slate-900" data-id="element-724">5%</span>
              </div>
              <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden" data-id="element-725">
                <div className="h-full bg-gradient-to-r from-amber-500 to-amber-600 rounded-full" style={{
                width: '5%'
              }} data-id="element-726"></div>
              </div>
              <p className="text-xs text-slate-500 mt-1" data-id="element-727">Rp 5.1Jt</p>
            </div>
          </div>
        </Card>
      </div>

      {/* Monthly Comparison */}
      <Card className="p-6" data-id="element-728">
        <div className="flex items-center gap-3 mb-6" data-id="element-729">
          <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center" data-id="element-730">
            <Calendar className="w-5 h-5 text-green-600" data-id="element-731" />
          </div>
          <div data-id="element-732">
            <h3 className="font-bold text-lg text-slate-900" data-id="element-733">
              Perbandingan Bulanan
            </h3>
            <p className="text-sm text-slate-500" data-id="element-734">3 bulan terakhir</p>
          </div>
        </div>

        <div className="overflow-x-auto" data-id="element-735">
          <table className="w-full" data-id="element-736">
            <thead data-id="element-737">
              <tr className="border-b border-slate-200" data-id="element-738">
                <th className="text-left py-3 px-4 text-sm font-bold text-slate-700" data-id="element-739">
                  Bulan
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-740">
                  Revenue
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-741">
                  Gross Margin
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-742">
                  Net Profit
                </th>
                <th className="text-right py-3 px-4 text-sm font-bold text-slate-700" data-id="element-743">
                  Growth
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-744">
              <tr className="hover:bg-slate-50" data-id="element-745">
                <td className="py-3 px-4 font-medium text-slate-900" data-id="element-746">
                  Oktober 2023
                </td>
                <td className="py-3 px-4 text-right font-bold text-blue-600" data-id="element-747">
                  Rp 125.000.000
                </td>
                <td className="py-3 px-4 text-right font-medium text-slate-900" data-id="element-748">
                  18,5%
                </td>
                <td className="py-3 px-4 text-right font-bold text-green-600" data-id="element-749">
                  Rp 23.000.000
                </td>
                <td className="py-3 px-4 text-right" data-id="element-750">
                  <Badge variant="success" data-id="element-751">+12%</Badge>
                </td>
              </tr>
              <tr className="hover:bg-slate-50" data-id="element-752">
                <td className="py-3 px-4 font-medium text-slate-900" data-id="element-753">
                  September 2023
                </td>
                <td className="py-3 px-4 text-right font-bold text-blue-600" data-id="element-754">
                  Rp 112.000.000
                </td>
                <td className="py-3 px-4 text-right font-medium text-slate-900" data-id="element-755">
                  17,8%
                </td>
                <td className="py-3 px-4 text-right font-bold text-green-600" data-id="element-756">
                  Rp 19.900.000
                </td>
                <td className="py-3 px-4 text-right" data-id="element-757">
                  <Badge variant="success" data-id="element-758">+8%</Badge>
                </td>
              </tr>
              <tr className="hover:bg-slate-50" data-id="element-759">
                <td className="py-3 px-4 font-medium text-slate-900" data-id="element-760">
                  Agustus 2023
                </td>
                <td className="py-3 px-4 text-right font-bold text-blue-600" data-id="element-761">
                  Rp 104.000.000
                </td>
                <td className="py-3 px-4 text-right font-medium text-slate-900" data-id="element-762">
                  17,2%
                </td>
                <td className="py-3 px-4 text-right font-bold text-green-600" data-id="element-763">
                  Rp 17.900.000
                </td>
                <td className="py-3 px-4 text-right" data-id="element-764">
                  <Badge variant="success" data-id="element-765">+5%</Badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}